export default {
    settings: [],
    getSetting (key, defaultSetting) {
        let value = null
        let keys = key.split('.')

        let setting = this.settings
        for(let keyIndex in keys) {
            if (undefined !== keys[keyIndex] && undefined !== setting[keys[keyIndex]]) {
                setting = setting[keys[keyIndex]]
                value = setting
            } else {
                value = null
            }
        }

        if (value === null || value === '' || value === undefined) {
            setting = Mantle.Setting.defaultSettings
            for(let keyIndex in keys) {
                if (undefined !== keys[keyIndex] && undefined !== setting) {
                    setting = setting[keys[keyIndex]]
                    value = setting
                } else {
                    value = null
                }
            }
        }

        if (value === null || value === '' || value === undefined) {
            return defaultSetting
        }
        return value
    },
    setSetting(key, value) {
        this.settings[key] = value
    },
    getTaxes() {
        let taxes = Core.Session.Setting.getSetting('commerce.taxes')
        if (taxes !== '' && !Array.isArray(taxes)) {
            taxes = JSON.parse(taxes)
        }
        return taxes
    }
}